import ApiPermisos from "./../../services/apiPermisos";

export default {
  namespaced: true,
  state: {
    errorMsj: "",
    categories: [],
    tipshift: [],
    tipshiftCopia: [],
    loading: false,
    loadingAutocomplete: false,
    loadingConfirmar: false,
    selectAll: false, // select-all - deselect-all
    selectAllLock: false, // select-all - deselect-all
    novedades: [],
    novedadesCopia: [],
    puntoVenta: null,
    filterTipshift: {
      query: "",
    },
    listAutocompleteNovedad: [],
    listAutocompleteReemplazo: [],
    checkedNovedad: true,
    buscadorNovedad: "",
    algunSeleccionado: true, // False => ninguno, true => alguno
    algunSeleccionadoLock: true, // False => ninguno, true => alguno
    bodegas: [],
    bodegaSelected: null,
    lastDateTipshiftReport: null,
    charges: [],
  },
  getters: {
    getLastDateTipshiftReport: (state) => {
      return state.lastDateTipshiftReport;
    },
    getTotalNovedades: (state) => {
      let total = state.novedades.filter((row) => row.type == 1);
      return total.length;
    },
    getTotalRotativos: (state) => {
      let total = state.novedades.filter((row) => row.type == 2);
      return total.length;
    },

    getNovedades: (state) => {
      return state.novedades.filter((row) => row.type == 1);
    },

    getCharges: (state) => {
      return state.charges.map(function(charge) {
        charge.value = charge.id;
        charge.text = charge.name;
        return charge;
      });
    },

    getRotativos: (state) => {
      return state.novedades.filter((row) => row.type == 2);
    },

    getAllSelected: (state) => (selected, editar, date) => {
      let turnos = [];
      turnos = state.tipshift.filter(function(row) {
        if (row.selected === selected || row.descanso) {
          return true;
        }
        return false;
      });
      turnos = turnos.map(function(turno) {
        if (editar != null) {
          return {
            position_id: turno.position_id,
            is_direct: turno.is_direct,
            core_employee_id: turno.core_employee_id,
            date: date,
            status: turno.descanso ? 2 : 1,
          };
        } else {
          return {
            position_id: turno.position_id,
            is_direct: turno.is_direct,
            core_employee_id: turno.core_employee_id,
            status: turno.descanso ? 2 : 1,
          };
        }
      });
      return turnos;
    },
    getAllNovedades: (state) => (data, date) => {
      return state.novedades.map(function(novedad) {
        if (date == null) {
          return {
            id: novedad.id,
            type: novedad.type,
            description: data.description,
            core_employee_id: novedad.core_employees_id
                ? novedad.core_employees_id
                : novedad.core_employee_id,
            position_id: novedad.position_id,
            position_replacement_id: novedad.nuevoCargoId,
            status: novedad.status == undefined ? 1 : novedad.status,
          };
        } else {
          return {
            id: novedad.id,
            type: novedad.type,
            description: data.description,
            core_employee_id: novedad.core_employees_id
                ? novedad.core_employees_id
                : novedad.core_employee_id,
            position_id: novedad.position_id,
            position_replacement_id: novedad.nuevoCargoId,
            date: date,
            status: novedad.status == undefined ? 1 : novedad.status,
          };
        }
      }, data);
    },
    getAll: (state) => {
      return state.tipshift;
    },

    filteredTipshift(state) {
      let tipshift = state.tipshift;
      if (state.filterTipshift.query.length > 0) {
        return tipshift.filter(function(item) {
          let nombre = item.nombre
              .toLowerCase()
              .includes(state.filterTipshift.query.toLowerCase());
          let cargo = item.cargo
              .toLowerCase()
              .includes(state.filterTipshift.query.toLowerCase());
          let cc = item.cc
              .toLowerCase()
              .includes(state.filterTipshift.query.toLowerCase());
          if (nombre || cargo || cc) {
            return true;
          }
          return false;
        });
      }
      return tipshift;
    },

    getLoading(state) {
      return state.loading;
    },
  },

  mutations: {
    setLastDateTipshiftReport: (state, lastDateTipshiftReport) => {
      state.lastDateTipshiftReport = [];
      state.lastDateTipshiftReport = lastDateTipshiftReport;
    },

    setPuntoVenta: (state, puntoVenta) => {
      state.puntoVenta = [];
      state.puntoVenta = puntoVenta;
    },

    setBodegas: (state, bodegas) => {
      state.bodegas = [];
      state.bodegas = bodegas;
    },

    setCharges: (state, charges) => {
      state.charges = [];
      state.charges = charges;
    },

    setCharge: (state, data) => {
      state.novedades = state.novedades.map(function(novedad) {

        if (novedad.cc == data.novedad.cc) {
          novedad.nuevoCargoId = data.charge.id;
          novedad.nuevoCargoName = data.charge.name;
        }
        return novedad;
      });
    },

    setTipshift: (state, tipshift) => {
      state.tipshift = [];
      state.tipshiftCopia = [];
      state.tipshift = tipshift;
      state.tipshiftCopia = tipshift;
    },
    setNovedades: (state, novedades) => {
      state.novedades = [];
      state.novedades = novedades;
      state.novedadesCopia = novedades;
    },
    setLoading: (state, loading) => {
      state.loading = loading;
    },

    setLoadingConfirmar: (state, loadingConfirmar) => {
      state.loadingConfirmar = loadingConfirmar;
    },

    setLoadingAutocomplete: (state, loadingAutocomplete) => {
      state.loadingAutocomplete = loadingAutocomplete;
    },

    setSelectAll: (state, selectAll) => {
      // Recorrer cada registro
      state.tipshift = state.tipshift.map(function(row) {
        row.selected = selectAll;
        return row;
      });
      state.selectAll = "";
      state.selectAll = selectAll;
      state.algunSeleccionado = !selectAll;
    },
    setSelectAllLock: (state, selectAllLock) => {
      // Recorrer cada registro
      state.tipshift = state.tipshift.map(function(row) {
        if (selectAllLock) {
          row.selected = !selectAllLock;
        }
        row.descanso = selectAllLock;
        return row;
      });
      state.selectAllLock = "";
      state.selectAllLock = selectAllLock;
      state.algunSeleccionadoLock = !selectAllLock;
    },
    // Cambiar el estado del registro
    setToggleSelectRow: (state, tipshift) => {
      let copiaTipshift = state.tipshift;
      state.tipshift = [];
      let row = {};
      let row_selected = null;
      // Deseleccionar todos
      if (!tipshift.selected) {
        state.selectAll = false;
      } else {
        // Seleccionar todos
        row_selected = copiaTipshift.find((row) => row.selected == false);
        if (row_selected == null) {
          state.selectAll = true;
        }
      }
      row = copiaTipshift.find((row) => row.id === tipshift.id);
      row.selected = tipshift.selected;

      // validar si todos estan deseleccionados
      row_selected = copiaTipshift.find((row) => row.selected == true);
      if (row_selected == null) {
        state.algunSeleccionado = true;
      } else {
        state.algunSeleccionado = false;
      }

      state.tipshift = copiaTipshift;
    },

    setToggleSelectRowLock: (state, tipshift) => {
      let copiaTipshift = state.tipshift;
      state.tipshift = [];
      let row = {};
      let row_selected = null;
      // Deseleccionar todos
      if (!tipshift.descanso) {
        state.selectAll = false;
      } else {
        // Seleccionar todos
        row_selected = copiaTipshift.find((row) => row.descanso == false);
        if (row_selected == null) {
          state.selectAll = true;
        }
      }
      row = copiaTipshift.find((row) => row.id === tipshift.id);
      row.descanso = tipshift.descanso;

      // validar si todos estan deseleccionados
      row_selected = copiaTipshift.find((row) => row.descanso == true);
      if (row_selected == null) {
        state.algunSeleccionado = true;
      } else {
        state.algunSeleccionado = false;
      }

      state.tipshift = copiaTipshift;
    },

    // Setear el estado de la novedad
    setToggleSelectNovedad: (state, novedad) => {
      state.checkedNovedad = novedad;
    },

    // Setear el buscador de la novedad
    setbuscadorNovedad: (state, buscadorNovedad) => {
      state.buscadorNovedad = buscadorNovedad;
    },

    // Setear el buscador de la novedad
    setAutocompleteNovedad: (state, novedades) => {
      state.listAutocompleteNovedad = novedades;
    },

    // Setear el listado del autocomplete
    setPushNovedad: (state, novedad) => {
      state.novedades.push(novedad);
    },

    // Setear el listado del autocomplete
    setCheckedNovedad: (state, checkedNovedad) => {
      state.checkedNovedad = checkedNovedad;
    },

    // Setear el listado del autocomplete
    setNovedad: (state, novedades) => {
      state.novedadesCopia = novedades;
      state.novedades = novedades;
    },
    // Eliminar un dato de la lista
    setDeleteRegistroNovedad: (state, id) => {
      state.novedades = state.novedades.filter((novedad) => novedad.id != id);
    },

    SET_QUERY(state, query) {
      state.filterTipshift.query = query;
    },
  },

  actions: {
    // Guarda los reportes de turnos
    actSaveTipshift: async ({ commit }, data) => {
      commit("setLoading", true);
      let response = await ApiPermisos.saveRightPetition(data);
      commit("setLoading", false);
      if (response.error) {
        commit("errorMsj", response);
        return response.error;
      } else {
        return response;
      }
    },

    //Trae listado de las personas
    actGetTipshift: async ({ commit }, data) => {
      try {
        let response;
        commit("setLoading", true);
        commit("setLastDateTipshiftReport", null);
        if (data.rol == "supervisor-bodegas") {
          // Obtener por bodegas
          response = await ApiPermisos.getTipshiftBodega(data);
        } else {
          // Obtener por usuario
          response = await ApiPermisos.getTipshift(data.id_user);
        }

        commit("setPuntoVenta", response.pro_point_sale);
        commit("setCharges", response.charges);
        let responseEditar;
        let datos;
        let datosDefault;
        if (data.editar) {
          responseEditar = await ApiPermisos.getTipshiftEditar(data);
          datos = responseEditar.data;
        }
        if (response.error) {
          commit("setLoading", false);
          return response;
        } else {
          commit("setLastDateTipshiftReport", response.lastDate);
          // data
          let datatable = [];
          let datatableNovedades = [];
          // crear
          datosDefault = response.data.data;
          for (let i = 0; i < datosDefault.length; i++) {
            // formatear cadenas
            let nombre = datosDefault[i].core_employee.name,
                cargo = datosDefault[i].core_employee.position.name;

            nombre = nombre.toString();
            cargo = cargo.toString();

            nombre = nombre.toUpperCase();
            cargo = cargo.toLowerCase();

            nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1);
            cargo = cargo.charAt(0).toUpperCase() + cargo.slice(1);

            // Calcular los sleccionados
            let colaboradorSelected = false;
            let colSelected = null;
            if (data.editar) {
              colaboradorSelected = datos.colaboradores.find(
                  (colaborador) =>
                      colaborador.core_employee_id ==
                      datosDefault[i].core_employees_id
              );
              colSelected = colaboradorSelected;
              colaboradorSelected = colaboradorSelected != null ? true : false;
            }

            datatable.push({
              id: datosDefault[i].id,
              nombre: nombre,
              cc: datosDefault[i].core_employee.cc,
              core_role_id:
                  datosDefault[i].core_employee.core_role.id == null
                      ? null
                      : datosDefault[i].core_employee.core_role.id,
              cargo_id:
                  datosDefault[i].core_employee.position == null
                      ? null
                      : datosDefault[i].core_employee.position.id,
              cargo:
                  datosDefault[i].core_employee.position == null
                      ? "No se encontró el cargo"
                      : cargo,
              tiene_novedad: datosDefault[i].tiene_novedad,
              is_direct: datosDefault[i].is_direct,
              pro_point_sale_id: response.pro_point_sale.id,
              pro_point_sale_name:
                  datosDefault[i].pro_points_sale != undefined
                      ? datosDefault[i].pro_points_sale.name
                      : response.pro_point_sale.name,
              core_employee_id: datosDefault[i].core_employee.id,
              position_id: datosDefault[i].core_employee.position.id,
              selected: colaboradorSelected
                  ? colSelected.status == 1
                      ? true
                      : false
                  : false,
              point: datosDefault[i].point,
              close_value: colaboradorSelected
                  ? colSelected.close_value
                  : datosDefault[i].close_value,
              descanso: colaboradorSelected
                  ? colSelected.status == 2
                      ? true
                      : false
                  : false,
            });
          }
          commit("setTipshift", datatable);

          // validar si es para editar
          if (data.editar) {
            // Llenar novedades
            for (let i = 0; i < datos.novedades.length; i++) {
              // formatear cadenas
              let nombre = datos.novedades[i].core_employee.name,
                  cargo = datos.novedades[i].core_employee.position.name;
              nombre = nombre.toString();
              cargo = cargo.toString();
              nombre = nombre.toLowerCase();
              cargo = cargo.toLowerCase();
              nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1);
              cargo = cargo.charAt(0).toUpperCase() + cargo.slice(1);
              let core_employe = datos.novedades[i].core_employee;
              core_employe.name = nombre;
              core_employe.position.name = cargo;
              core_employe.id_item = datos.novedades[i].id;
              core_employe.core_employee_id =
                  datos.novedades[i].core_employee.id;
              core_employe.core_role = datos.novedades[i].core_role;
              core_employe.date = datos.novedades[i].date;
              core_employe.description = datos.novedades[i].description;
              core_employe.points = datos.novedades[i].points;
              core_employe.position_id = datos.novedades[i].position_id;
              core_employe.pro_close_point = datos.novedades[i].pro_close_point;
              core_employe.pro_close_point_sale_id =
                  datos.novedades[i].pro_close_point_sale_id;
              core_employe.pro_point_sale_id =
                  datos.novedades[i].pro_point_sale_id;
              core_employe.status = datos.novedades[i].status;
              core_employe.is_direct =
                  datos.novedades[i].pro_collaborators_point_sale.is_direct;
              core_employe.close_value =
                  datos.novedades[i].pro_collaborators_point_sale.is_direct;
              core_employe.type = datos.novedades[i].type;

              core_employe.nuevoCargoId = datos.novedades[i].position.id;
              core_employe.nuevoCargoName = datos.novedades[i].position.name;
              datatableNovedades.push(core_employe);
            }
            commit("setNovedad", datatableNovedades);
          }
          commit("setLoading", false);
        }
        return response;
      } catch (error) {
        console.log(error);
      }
    },

    //Selecciona o delesecciona el contenido del datatable
    actGetSelectAll: async ({ commit }, data) => {
      commit("setLoading", true);
      commit("setLoading", false);
      commit("setSelectAll", data);

      return true;
    },

    actGetSelectAllLock: async ({ commit }, data) => {
      commit("setLoading", true);
      commit("setLoading", false);
      commit("setSelectAllLock", data);

      return true;
    },

    // Seleccionar un row
    actSelectRow: async ({ commit }, data) => {
      commit("setLoading", true);
      commit("setLoading", false);
      commit("setToggleSelectRow", data);

      return true;
    },

    // Seleccionar un cargo
    actSelectCargo: async ({ commit }, data) => {
      commit("setLoading", true);
      commit("setLoading", false);
      commit("setCharge", data);

      return true;
    },

    actSelectRowLock: async ({ commit }, data) => {
      commit("setLoading", true);
      commit("setLoading", false);
      commit("setToggleSelectRowLock", data);

      return true;
    },

    // Toggle checked
    actCheckedNovedad: async ({ commit }, data) => {
      commit("setLoading", true);
      commit("setLoading", false);
      commit("setToggleSelectNovedad", data);

      return true;
    },

    // Mostrar cambios en el buscador
    actSetBuscardorNovedad: async ({ commit }, data) => {
      commit("setLoading", true);
      commit("setLoading", false);
      commit("setbuscadorNovedad", data);
      return true;
    },

    // Autocomplete novedades
    actGetNovedades: async ({ commit }, data) => {
      commit("setLoadingAutocomplete", true);
      let response = await ApiPermisos.getAutocompleteNovedades(data);
      if (response.error) {
        commit("setLoadingAutocomplete", false);
        return response.error;
      } else {
        commit("setLoadingAutocomplete", false);
        commit(
            "setAutocompleteNovedad",
            response != null ? response.data.data : null
        );
      }
      return true;
    },

    // Act limpiar novedades
    actSetNullNovedades: async ({ commit }) => {
      commit("setLoading", true);
      commit("setAutocompleteNovedad", []);
      commit("setLoading", false);
    },

    // Setear la tabla de novedades
    actSetTableNovedades: async ({ commit }, data) => {
      commit("setLoading", true);
      commit("setLoading", false);
      commit("setNovedad", data);
      return true;
    },

    // Agregar un item a la tabla
    actPushTableNovedades: async ({ commit }, data) => {
      commit("setLoading", true);
      commit("setLoading", false);
      commit("setPushNovedad", data);
      return true;
    },

    // Elimina un registro de novedad
    actEliminarRegistroNovedad: async ({ commit }, data) => {
      commit("setLoading", true);
      commit("setLoading", false);
      commit("setDeleteRegistroNovedad", data);
      return true;
    },

    actSaveTurnosNovedades: async ({ commit }, data) => {
      try {
        commit("setLoading", true);
        commit("setLoadingConfirmar", true);
        let response = await ApiPermisos.saveNovedades(data);
        if (response.error) {
          commit("setLoading", false);
          commit("setLoadingConfirmar", false);
        } else {
          commit("setLoading", false);
          commit("setLoadingConfirmar", false);
        }
        return response;
      } catch (error) {
        console.log(error);
        return error;
      }
    },

    actUpdateTurnosNovedades: async ({ commit }, data) => {
      try {
        commit("setLoading", true);
        commit("setLoadingConfirmar", true);
        let response = await ApiPermisos.updateNovedades(data);
        if (response.error) {
          commit("setLoading", false);
          commit("setLoadingConfirmar", false);
        } else {
          commit("setLoading", false);
          commit("setLoadingConfirmar", false);
        }
        return response;
      } catch (error) {
        console.log(error);
      }
    },

    capitalize: async ({ commit }, value) => {
      commit("setLoading", true);
      if (!value) return "";
      value = value.toString();
      value = value.toLowerCase();
      commit("setLoading", false);
      return value.charAt(0).toUpperCase() + value.slice(1);
    },

    actSetFilterTipshift: async ({ commit }, value) => {
      commit("setLoading", true);
      commit("SET_QUERY", value);
      commit("setLoading", false);
    },

    actSetTipshift: async ({ commit }, value) => {
      commit("setLoading", true);
      commit("setTipshift", value);
      commit("setLoading", false);
    },

    actSetNovedades: async ({ commit }, value) => {
      commit("setLoading", true);
      commit("setNovedades", value);
      commit("setLoading", false);
    },

    actLoadBodegas: async ({ commit }) => {
      commit("setLoading", true);
      let response = await ApiPermisos.getBodegasSupervisor();
      if (response.error) {
        return response.error;
      } else {
        commit("setLoading", false);
        commit("setBodegas", response.data);
      }
      return true;
    },
  },
};
